import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { createHttpParams } from '~/infrastructure/http/params';
import { augmentPaging } from '~/infrastructure/paging';
import { PackListListing, PackListSummary, PackListWtihTransactionNumberListing } from '~/models/modules/packList';
import { ApiServiceBase, API_NAMES } from '~/services/api';
import { PackTransactionsService } from '~/services/modules/stocks/pack-transaction';
import { ShipTransactionsService } from '~/services/modules/stocks/ship-transaction';

@Injectable({ providedIn: 'root' })
export class PackListsService extends ApiServiceBase {
  packListClosed: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  constructor(injector: Injector, private http: HttpClient,
    private _packTransactionsService: PackTransactionsService,
    private _shipTransactionsService: ShipTransactionsService) {
    super(injector);
    this.setBase(API_NAMES.stocks);
  }

  getPackList(id: number) {
    return this.http.get<PackListSummary>(this._url(`/${id}`));
  }

  getPackListsListing() {
    return this.http.get<PackListListing[]>(this._url());
  }

  getPackListsListingForPack(packagainstso: boolean) {
    var ispacked = false;
    var isshipped = false;
    return this.http.get<PackListWtihTransactionNumberListing[]>(this._packTransactionsService.getUrl() + `/packlists/${packagainstso}/${ispacked}/${isshipped}`);
  }

  getPackListsListingForShip(shipagainstso: boolean, onlyshippacked: boolean) {
    var isshipped = false;
    return this.http.get<PackListWtihTransactionNumberListing[]>(this._shipTransactionsService.getUrl() + `/packlists/${shipagainstso}/${onlyshippacked}/${isshipped}`);
  }

  getPackLists(paramsObj?: any, model?: any) {
    paramsObj = paramsObj || {};
    paramsObj.view = 'summary';
    let params = createHttpParams(paramsObj);

    return this.http
      .post<PackListSummary[]>(this._url(`/grid-data`), model, {
        params,
        observe: 'response',
      })
      .pipe(map(augmentPaging));
  }

  getPackListsBySiteId(siteIds: number[]) {
    return this.http.post<PackListListing[]>(this._url(`/site`), { siteIds });
  }

  getAccountsPackLists(accountIds: any[], paramsObj?: any, model?: any) {
    paramsObj = paramsObj || {};
    paramsObj.view = 'summary';
    let params = createHttpParams(paramsObj);

    model['accountIds'] = accountIds;

    return this.http
      .post<PackListSummary[]>(this._url(`/accounts`), model, {
        params,
        observe: 'response',
      })
      .pipe(map(augmentPaging));
  }

  createPackList(model: any) {
    return this.client.post<string>(this._url(), model);
  }

  updatePackList(id: number, model: any) {
    return this.client.put(this._url(`/${id}`), model);
  }

  deletePackList(id: number) {
    return this.client.delete(this._url(`/${id}`));
  }
  deactivatePackList(obj: any) {
    return this.client.put(this._url(`/deactivate`), obj);
  }

  reactivatePackList(obj: any) {
    return this.client.put(this._url(`/reactivate`), obj);
  }

  private _url(v?: string | undefined) {
    v = v || '';
    return this.url(`/PackTransactions${v}`);
  }

  packListFormClosed(newPackList: any) {
    this.packListClosed.next(newPackList);
  }
}
